import { Toastr } from '@components/modals/Toastr';
import { UpdatePrompt } from '@components/modals/UpdatePrompt';
import { initAppInsights, reactPlugin, withAITracking } from '@utils/AppInsights';
import { installBlockMetaInvalidator } from '@utils/blockMetaInvalidator';
import httpClient from '@utils/httpClient';
import { getToken, getUser } from '@utils/tokenStorage';
import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';

import { Routing } from './routing';
import { getStore, history } from './store/configureStore';
import { blocksRefreshMetaRequest } from './store/slices/blocks/blocksSlice';
import Global from './styles/global';

const token = getToken();
const user = getUser();
const initialState = { auth: { token, email: user } };

export const store = getStore(initialState);

installBlockMetaInvalidator(httpClient, () => store.dispatch(blocksRefreshMetaRequest()));

initAppInsights({ history });

const TrackedApp = withAITracking(reactPlugin, () => (
  <HelmetProvider>
    <Global />
    <Provider store={store}>
      <Routing />
      {/* One instance for the whole app: toasts fired from the mobile shell, the wizard or login
          used to be dispatched into a store nobody rendered — only AdminPanel mounted the host. */}
      <Toastr />
      {/* Prod deploys swap the hashed bundles under running tabs: offer a reload instead of
          leaving people on a build whose chunks are already gone. */}
      <UpdatePrompt />
    </Provider>
  </HelmetProvider>
));

const App = ({ isCustomDomain, username }) => <TrackedApp isCustomDomain={isCustomDomain} username={username} />;

// const App = () => (
//   <>
//     <Global />
//     <Provider store={store}>
//       <Routing />
//     </Provider>
//   </>
// );

export default App;
